import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { LocaleSingularArg } from '@fullcalendar/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Address } from 'src/app/core/models/address.model';
import { Board } from 'src/app/core/models/board.model';
import { Location } from 'src/app/core/models/location.model';
import { SalesRep } from 'src/app/core/models/sales-rep.model';
import { UserType } from 'src/app/core/models/userType.models';
import { BoardService } from 'src/app/core/services/board.service';
import { LocationService } from 'src/app/core/services/location.service';
import { LoginService } from 'src/app/core/services/login.service';
import { SalesRepService } from 'src/app/core/services/sales-rep.service';
import { CollectionModalComponent } from '../collectionModal/collection-modal.component';


@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})

/**
 * Dashboard Component
 */
export class LocationComponent implements OnInit {
  term: any;
  readonly: boolean = false
  salesReps: SalesRep[];
  salesRepOptions: Array<SalesRep & { displayName: string }> = [];
  address: Address[];
  board: Board[];
  location: Location[];
  filteredLocation: Location[];
  filteredPagenatedLocations: Location[];

  addEditMode: any;
  addEditFormGroup: FormGroup;

  pageSize = 50;
  pageNumber = 0;
  numberOfPages = 0;

  constructor(private salesRepService: SalesRepService, 
    private locationService: LocationService, private boardService: BoardService,
     private modalService: NgbModal, private loginService: LoginService,
    private datePipe: DatePipe) {
  }

  // bread crumb items
  breadCrumbItems: Array<{}>;

  async ngOnInit(): Promise<void> {
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Locations', active: true }];
    this.readonly = this.isRestrictedSalesUser();

    await this.refresh();
  }

  private isRestrictedSalesUser(): boolean {
    return this.loginService.userType === UserType.EXTERNAL || this.loginService.userType === UserType.CUSTOMER;
  }

  private belongsToCurrentSalesRep(location?: Location): boolean {
    if (!this.isRestrictedSalesUser()) {
      return true;
    }

    const loggedInId = (this.loginService.userId || '').replace(/-/g, '').toLowerCase();
    const repId = (location?.salesRep?.id || '').replace(/-/g, '').toLowerCase();
    return !!repId && repId === loggedInId;
  }

  async refresh() {
    this.readonly = this.isRestrictedSalesUser();

    if (!this.readonly) {
      this.salesReps = await this.salesRepService.getAll();
      this.salesRepOptions = (this.salesReps || [])
        .map(rep => ({
          ...rep,
          displayName: `${rep.firstName || ''} ${rep.lastName || ''}`.trim()
        }))
        .sort((a, b) => a.displayName.localeCompare(b.displayName));
      this.board = await this.boardService.getAll();
    }

    const allLocations = await this.locationService.getAll();
    this.location = (allLocations || []).filter((location) => this.belongsToCurrentSalesRep(location));
    this.updateFilteredLocations();
  }

  onSearch() {
    const termLower = (this.term ?? '').toLowerCase().trim();  // Precompute lowercase and trim for search term
    this.updateFilteredLocations(termLower);
  }

  async onAddNew(modal: unknown) {
    this.addEditMode = "Add";
    this.addEditFormGroup = new FormGroup({
      locationTag: new FormControl<string>(''),
      locationName: new FormControl<string>(''), 
      boardInfo: new FormControl<string>(''),
      salesRep: new FormControl<string>(''),
      locationStartDate: new FormControl<Date | null>(null),
      locationEndDate: new FormControl<Date | null>(null),


      enabled: new FormControl<boolean>(true),            
      businessAddress: new FormGroup({
        streetAddress1: new FormControl<string>(''),
        streetAddress2: new FormControl<string>(''),
        city: new FormControl<string>(''),
        state: new FormControl<string>(''),
        zipCode: new FormControl<string>(''),
        country: new FormControl<string>(''),
      }),
    });
    try {
      const results = await this.modalService.open(modal).result;
      //console.log('add edit modal returned', {results, addEditFormGroup: this.addEditFormGroup.value});
      if(results=="Save click") {
        const newLocationData = this.addEditFormGroup.value
       if (newLocationData.boardInfo) {
            newLocationData.boardInfo = { id: newLocationData.boardInfo };
          }
          if (newLocationData.salesRep) {
            newLocationData.salesRep = { id: newLocationData.salesRep };
          }
          newLocationData.locationStartDate = newLocationData.locationStartDate
  ? this.datePipe.transform(newLocationData.locationStartDate, 'yyyy-MM-dd')
  : null;
newLocationData.locationEndDate = newLocationData.locationEndDate
  ? this.datePipe.transform(newLocationData.locationEndDate, 'yyyy-MM-dd')
  : null;
        const location = await this.locationService.create(newLocationData);
        if(location != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      }
       else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
  }

  async onDelete(id: string) {
    await this.locationService.delete(id);
    await this.refresh();     
   
  }

async onEdit(modal: unknown, original: Location) {
  this.addEditMode = "Edit";

  // 🔁 Refresh this one location from the backend
  const freshLocation = await this.locationService.getById(original.id);

  if (!freshLocation) {
    console.error("⚠ Could not fetch updated location data.");
    return;
  }

  console.log("🟢 Fresh Location Start Date:", freshLocation.locationStartDate);

  this.addEditFormGroup = new FormGroup({
    locationTag: new FormControl<string>(freshLocation.locationTag),
    locationName: new FormControl<string>(freshLocation.locationName),
    salesRep: new FormControl<string>(freshLocation.salesRep?.id),
    enabled: new FormControl<boolean | number>(freshLocation.enabled),

          locationStartDate: new FormControl<string | null>(
        freshLocation.locationStartDate ?? null
      ),
      locationEndDate: new FormControl<string | null>(
        freshLocation.locationEndDate ?? null
      ),



    businessAddress: new FormGroup({
      streetAddress1: new FormControl<string>(freshLocation.businessAddress.streetAddress1),
      streetAddress2: new FormControl<string>(freshLocation.businessAddress.streetAddress2),
      city: new FormControl<string>(freshLocation.businessAddress.city),
      state: new FormControl<string>(freshLocation.businessAddress.state),
      zipCode: new FormControl<string>(freshLocation.businessAddress.zipCode),
      country: new FormControl<string>(freshLocation.businessAddress.country),
    }),
  });

  try {
    const results = await this.modalService.open(modal).result;

    if (results === "Save click") {
      const editLocationData = this.addEditFormGroup.value;

      if (editLocationData.boardInfo) {
        editLocationData.boardInfo = { id: editLocationData.boardInfo };
      }
      if (editLocationData.salesRep) {
        editLocationData.salesRep = { id: editLocationData.salesRep };
      }

      editLocationData.locationStartDate = editLocationData.locationStartDate
        ? this.datePipe.transform(editLocationData.locationStartDate, 'yyyy-MM-dd')
        : null;

      editLocationData.locationEndDate = editLocationData.locationEndDate
        ? this.datePipe.transform(editLocationData.locationEndDate, 'yyyy-MM-dd')
        : null;

      console.log('Saving location:', editLocationData);

      const updated = await this.locationService.update(freshLocation.id, editLocationData);
      if (updated != null) {
        // Success
      } else {
        // Failure
      }
    } else {
      // Canceled
    }
  } catch (error) {
    // Error
  }

  await this.refresh();
}

  async onChange() {
   console.log("Start Date field value:", this.addEditFormGroup.get('locationStartDate')?.value);
  }

updateFilteredLocations(filter: any = null) {
  let locationsToFilter = this.location;

  // ✅ Filter out locations with zero boards
  locationsToFilter = locationsToFilter.filter(l => l.numBoards && l.numBoards > 0);

  if (filter) {
    const lower = filter.toLowerCase();
    this.filteredLocation = locationsToFilter.filter(l => {
      const salesRepFullName = `${l.salesRep?.firstName ?? ''} ${l.salesRep?.lastName ?? ''}`.trim().toLowerCase();
      return (
        (l.locationTag?.toLowerCase().includes(lower)) ||
        (l.locationName?.toLowerCase().includes(lower)) ||
        (l.salesRep?.firstName?.toLowerCase().includes(lower)) ||
        (l.salesRep?.lastName?.toLowerCase().includes(lower)) ||
        salesRepFullName.includes(lower) ||
        (l.businessAddress?.streetAddress1?.toLowerCase().includes(lower)) ||
        (l.businessAddress?.city?.toLowerCase().includes(lower)) ||
        (l.businessAddress?.state?.toLowerCase().includes(lower)) ||
        (l.businessAddress?.zipCode?.toLowerCase().includes(lower))
      );
    });
  } else {
    this.filteredLocation = locationsToFilter;
  }

  this.numberOfPages = Math.ceil(this.filteredLocation.length / this.pageSize);
  this.updatePagination();
}


      updatePagination() {
      const pageStart = this.pageSize * this.pageNumber;
      const pageStop = Math.min(pageStart + this.pageSize, this.filteredLocation.length);
      this.filteredPagenatedLocations = this.filteredLocation.slice(pageStart, pageStop);
    }

        canDecrement() {
      return this.pageNumber > 0;
    }

    decrementPage() {
      if (this.pageNumber > 0) {
        this.pageNumber--;
      }
      this.updateFilteredLocations();
    }

    canIncrement() {
      return this.pageNumber < this.numberOfPages -1;
    }

 incrementPage() {
  if (this.pageNumber < this.numberOfPages - 1) {
    this.pageNumber++;
    this.updateFilteredLocations();
  }
}

openCollectionModal(location: Location): void {
  const modalRef = this.modalService.open(CollectionModalComponent, { size: 'xl' });
  modalRef.componentInstance.selectedLocationId = location.id;
  modalRef.componentInstance.allowNonPendingLocation = true;
}

canEdit(loc: Location): boolean {
  return this.loginService.userType !== UserType.EXTERNAL;
}

canGenerateCollection(loc: Location): boolean {
  const user = this.loginService.user;

  if (!user || !user.id || !this.loginService.isloggedIn) {
    return false;
  }

  const type = this.loginService.userType;

  if (['ROOT', 'INTERNAL', 'TECH'].includes(type)) {
    return true;
  }

  if (type === 'EXTERNAL') {
    return loc.salesRep?.id === user.id;
  }

  return false;
}
async onToggleSalesOutlet(row: Location, value: boolean) {
  const prev = row.salesOutlet;
  row.salesOutlet = value; // optimistic
  try {
    await this.locationService.setSalesOutlet(row.id, value);
  } catch {
    row.salesOutlet = prev; // revert on failure
  }
}





}
